// Срок поставки по матрице выбранной квоты (см. matrix-ключи в KPPanel.handleUpdateKP).
//   Склад → 1-3 дня, РФ → 2-3 недели, Китай/Стоки → 4-6 недель, Производители → 12-16 недель
// Единая точка правды для Excel- и PDF-генераторов КП (вынесено в отдельный
// файл, чтобы PDF-чанк не тянул за собой тяжёлый ExcelJS из generateKP.ts).
export function deliveryTimeByMatrix(matrix?: string): string {
  switch (matrix) {
    case 'stock':
      return '1-3 дня'
    case 'rf':
      return '2-3 недели'
    case 'china':
    case 'other':
      return '4-6 недель'
    case 'manuf':
      return '12-16 недель'
    default:
      return ''
  }
}
